module.exports = __webpack_public_path__ + "img/Jump Casting121.2b70124a.jpg";